/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；
 *          视觉基准 docs/旅游落地页/cj商旅-01.html 第 5723~6037 行（.cjbt-luxury-services）。
 * 注意事项：
 * 1. 含两个子模块：三张服务卡（Transportation / Hotels / Sightseeing）与 Destinations 城市标签墙。
 * 2. 纯静态展示，原型无对应脚本；卡片列表条数各不相同（5/5/8），按数据渲染不做统一裁剪。
 * 3. 城市墙最后一枚「Other China Cities」在原型上多挂 --more 修饰类（样式不同），单独渲染。
 */
import React from 'react';
import { ServiceIcon } from './Icons';

export default function Services(props) {
  var SVC = props.data;

  return (
    <section className="cjbt-luxury-services" id="china-travel-services">
      <div className="cjbt-luxury-services__container">

        {/* HEADING */}
        <div className="cjbt-luxury-services__heading">
          <div className="cjbt-luxury-services__eyebrow">{SVC.eyebrow}</div>
          <h2 className="cjbt-luxury-services__title">
            {SVC.titleLead} <em>{SVC.titleEm}</em>
          </h2>
          <p className="cjbt-luxury-services__description">{SVC.description}</p>
        </div>

        {/* SERVICES */}
        <div className="cjbt-luxury-services__grid">
          {SVC.cards.map(function (card) {
            return (
              <article className="cjbt-luxury-services__card" key={card.number}>

                <div className="cjbt-luxury-services__card-top">
                  <span className="cjbt-luxury-services__icon"><ServiceIcon name={card.icon} /></span>
                  <span className="cjbt-luxury-services__number">{card.number}</span>
                </div>

                <h3>{card.title}</h3>
                <p className="cjbt-luxury-services__card-intro">{card.intro}</p>

                <div className="cjbt-luxury-services__divider"></div>

                <ul className="cjbt-luxury-services__list">
                  {card.list.map(function (item, index) {
                    return <li key={index}>{item}</li>;
                  })}
                </ul>

                <div className="cjbt-luxury-services__notice">{card.notice}</div>

              </article>
            );
          })}
        </div>

        {/* DESTINATIONS */}
        <div className="cjbt-luxury-services__destinations">

          <div className="cjbt-luxury-services__destination-heading">
            <h3>{SVC.destinationTitle}</h3>
            <p>{SVC.destinationText}</p>
          </div>

          <div className="cjbt-luxury-services__cities">
            {SVC.cities.map(function (city, index) {
              return <span className="cjbt-luxury-services__city" key={index}>{city}</span>;
            })}
            <span className="cjbt-luxury-services__city cjbt-luxury-services__city--more">
              {SVC.cityMore}
            </span>
          </div>

        </div>
      </div>
    </section>
  );
}
